import { CreateButton, FilterButton, TopToolbar } from 'react-admin'

const CustomerListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton variant='contained' color='success' />
    </TopToolbar>
  )
}

export default CustomerListActions